/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_AttributeColorTypes {
    Ncs = 10,
    Ral = 20,
    Both = 30,
}
